import * as React from 'react';
import { getRandomOtherItems, IServiceItem } from '../utils';
import { useTrackClicks } from './useTrackClicks';

export interface IUseServicesModalProps {
  modalTitle: string;
  isModalOpen: boolean;
  onModalOpen: () => void;
  onModalClose: () => void;
  otherItems: IServiceItem[];
}

export const useServicesModalProps = (randomThreeItems: IServiceItem[]): IUseServicesModalProps => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [randomOtherItems, setOtherItems] = React.useState<IServiceItem[]>([]);
  const { trackAllServicesClick } = useTrackClicks();

  const handleModalOpen = React.useCallback(() => {
    setIsOpen(true);
    trackAllServicesClick();
  }, []);

  const handleModalClose = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  React.useEffect(() => {
    if (randomThreeItems.length) {
      const items = getRandomOtherItems(randomThreeItems);

      setOtherItems(items);
    }
  }, [randomThreeItems]);

  return {
    modalTitle: 'Все сервисы',
    isModalOpen: isOpen,
    onModalOpen: handleModalOpen,
    onModalClose: handleModalClose,
    otherItems: randomOtherItems,
  };
};
